export function refreshKlarna(): void {
  (window as any).Klarna = ((window as any)?.Klarna || []) as any;
  (window as any)?.Klarna?.OnsiteMessaging?.refresh();
}
